import { RouteConfig } from 'vue-router';
import ShiftWork from './pages/ShiftWork.vue';
import ShiftWorkList from './pages/ShiftWorkList.vue';
import ShiftWorkDetail from '@/libs/shifts/pages/ShiftWorkDetail.vue';
import Shifts from '@/libs/shifts/pages/Shifts.vue';
import ShiftReport from '@/libs/shifts/pages/ShiftReport.vue';
import { PermissionTypeEnum } from '@/libs/Api';

export default [
    {
        path: '/:tenantId/shift-work',
        name: 'ShiftWork',
        component: ShiftWork,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.ShiftManagement],
            checkLicence: true,
            title: 'menu.shiftWork',
        },
    },
    {
        path: '/:tenantId/shift-work-list',
        name: 'ShiftWorkList',
        component: ShiftWorkList,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.ShiftWork, PermissionTypeEnum.ShiftWorkLimited],
            checkLicence: true,
            title: 'menu.shiftWorkList',
        },
    },
    {
        path: '/:tenantId/shifts',
        name: 'Shifts',
        component: Shifts,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.ShiftManagement],
            checkLicence: true,
            title: 'menu.shifts',
        },
    },
    {
        path: '/:tenantId/shift-report',
        name: 'ShiftReport',
        component: ShiftReport,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.ShiftOverview],
            checkLicence: true,
            title: 'menu.shiftReport',
        },
    },
    {
        path: '/:tenantId/shift-work-detail/:id',
        name: 'ShiftWorkDetail',
        component: ShiftWorkDetail,
        props: (route) => ({ tenantId: route.params.tenantId, id: route.params.id }),
        meta: {
            permissions: [PermissionTypeEnum.ShiftWork, PermissionTypeEnum.ShiftWorkLimited],
            checkLicence: true,
            title: 'menu.shiftWorkDetails',
        },
    },
] as RouteConfig[];
